<h2 mat-dialog-title>{{ mode === 'add' ? 'Adaugă Antet' : 'Editare Antet' }}</h2>

<mat-dialog-content>
    <form [formGroup]="form" class="header-form">
        <!-- Nume -->
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Denumire</mat-label>
            <input matInput formControlName="name" placeholder="Ex: Antet Primărie Sector 4">
            <mat-error *ngIf="form.get('name')?.hasError('required')">
                Denumirea este obligatorie
            </mat-error>
        </mat-form-field>

        <!-- Tip Conținut -->
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Tip Conținut</mat-label>
            <mat-select formControlName="content_type">
                <mat-option *ngFor="let type of contentTypes" [value]="type.value">
                    {{ type.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Text Content -->
        <div *ngIf="showTextContent" class="mb-3">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Conținut Text (HTML)</mat-label>
                <textarea matInput formControlName="text_content" rows="4"
                    placeholder="<div style='text-align:center;'><strong>PRIMĂRIA</strong></div>"></textarea>
                <mat-hint>Puteți folosi HTML pentru formatare</mat-hint>
            </mat-form-field>
        </div>

        <!-- Image Upload -->
        <div *ngIf="showImageUpload" class="mb-3">
            <label class="form-label">Imagine Antet</label>
            <div class="image-upload-area">
                <div *ngIf="previewImageUrl" class="image-preview mb-2">
                    <img [src]="previewImageUrl" alt="Preview" class="img-fluid">
                    <button type="button" mat-icon-button color="warn" class="remove-btn" (click)="removeImage()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <div *ngIf="!previewImageUrl" class="upload-placeholder">
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Selectați o imagine</span>
                </div>
                <input type="file" accept="image/*" (change)="onFileSelected($event)" #fileInput hidden>
                <button type="button" mat-stroked-button (click)="fileInput.click()">
                    <mat-icon>upload</mat-icon>
                    {{ previewImageUrl ? 'Schimbă imaginea' : 'Încarcă imagine' }}
                </button>
            </div>
            <small class="text-muted">Format: JPG, PNG, GIF, SVG. Max 2MB.</small>
        </div>

        <!-- Aliniere -->
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Aliniere</mat-label>
            <mat-select formControlName="alignment">
                <mat-option *ngFor="let align of alignments" [value]="align.value">
                    {{ align.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Mod Afișare -->
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Mod Afișare</mat-label>
            <mat-select formControlName="display_mode">
                <mat-option *ngFor="let mode of displayModes" [value]="mode.value">
                    {{ mode.label }}
                </mat-option>
            </mat-select>
            <mat-hint>Alegeți dacă antetul apare doar pe prima pagină sau pe toate paginile</mat-hint>
        </mat-form-field>

        <!-- Status Activ -->
        <div class="mb-3">
            <mat-checkbox formControlName="is_active">Activ</mat-checkbox>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isLoading">Anulare</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isLoading || form.invalid">
        <mat-spinner *ngIf="isLoading" diameter="20" class="me-2"></mat-spinner>
        {{ mode === 'add' ? 'Adaugă' : 'Salvează' }}
    </button>
</mat-dialog-actions>
